import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { FiGlobe } from "react-icons/fi";

const InfiniteScrollUrls = ({
  usedDocs = [],
  allUrls = [],
  selectedUrls = [],
  toggleSelect,
}) => {
  const itemsPerLoad = 100;
  const [visibleUrls, setVisibleUrls] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    // Load initial batch
    const initialBatch = allUrls?.slice(0, itemsPerLoad);
    setVisibleUrls(initialBatch);
    setHasMore(initialBatch.length < allUrls.length);
  }, [allUrls]);

  const fetchMoreData = () => {
    const next = visibleUrls.length + itemsPerLoad;
    const nextBatch = allUrls?.slice(visibleUrls.length, next);
    setVisibleUrls((prev) => [...prev, ...nextBatch]);
    if (next >= allUrls.length) {
      setHasMore(false);
    }
  };

  return (
    <div
      id="scrollableDiv"
      className="flex flex-col gap-2 max-h-72 overflow-y-auto  rounded">
      <InfiniteScroll
        dataLength={visibleUrls.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={
          <div className="text-center py-3 text-gray-500 text-sm">
            Loading more...
          </div>
        }
        endMessage={
          <div className="text-center py-3 text-gray-400 text-sm">
            All links loaded
          </div>
        }
        scrollableTarget="scrollableDiv">
        {visibleUrls.map((url, index) => {
          const isUsed = usedDocs?.some((ele) => ele?.key_or_urls === url);
          return (
            <label
              key={url + index}
              className={`flex items-center gap-2 p-2 border rounded text-sm italic break-all ${
                isUsed ? "text-gray-600 " : "text-black"
              }`}>
              {!isUsed && (
                <input
                  type="checkbox"
                  checked={selectedUrls.includes(url)}
                  onChange={() => toggleSelect(url)}
                />
              )}
              <span className="flex flex-wrap gap-2 flex-1 items-center">
                {isUsed && <FiGlobe size={18} />}
                {url}
                {isUsed && (
                  <div className="bg-green-50 text-green-500 p-0.5 px-2 rounded-full w-fit">
                    Used
                  </div>
                )}
              </span>
            </label>
          );
        })}
      </InfiniteScroll>
    </div>
  );
};

export default InfiniteScrollUrls;
